<template>
  <div class="animate__animated animate__fadeIn">
    <div class="d-flex" v-if="MethodService.checkHaveFeature('FT1804')">
      <div class="form">
        <el-form
          class="form__create"
          ref="formCreate"
          :model="dataForm"
          :rules="validForm"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="1. Sử dụng mẫu" prop="dda_template_id">
                <el-select
                  :disabled="isEdit"
                  clearable
                  filterable
                  v-model="dataForm.dda_template_id"
                  placeholder="Chọn mẫu văn bản"
                  @change="onChangeTemplate(dataForm.dda_template_id)"
                >
                  <el-option
                    v-for="(item,index) in dataDefault.listTemplates"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="2. Phân loại mẫu">
                <el-select
                  disabled
                  v-model="dataForm.dda_category_id"
                  placeholder="Phân loại mẫu"
                >
                  <el-option
                    v-for="(item,index) in dataDefault.listCategories"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="3. Tên văn bản" prop="name">
                <el-input
                  type="textarea"
                  clearable
                  :autosize="{ minRows: 3, maxRows: 5}"
                  v-model="dataForm.name"
                  @change="() => {dataForm.name = dataForm.name.trim()}"
                  placeholder="Nhập tên văn bản"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="4. Số văn bản" prop="code">
                <el-input

                  :disabled="isEdit"
                  v-model.trim="dataForm.code"
                  clearable
                  placeholder="Nhập số văn bản"
                  @input="forceUpdateUI"
                  @change="() => {dataForm.code = dataForm.code.trim().toUpperCase(),changeCode(dataForm.code)}"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <p class="title-note mb-1">5. Thời điểm có hiệu lực (Mặc định thời điểm hiệu lực bắt đầu từ thời điểm hoàn thành ký)</p>
              <el-form-item prop="effected_date">
                <div class="d-flex custom-label" slot="label">
                  <span>Chuyển để tự cấu hình!</span>
                  <el-switch
                    v-model="haveEffectedDate"
                    @change="onChangeEffectedDate(haveEffectedDate)"
                  ></el-switch>
                </div>
                <el-date-picker
                  @input="forceUpdateUI"
                  :disabled="!haveEffectedDate"
                  clearable
                  v-model="dataForm.effected_date"
                  :picker-options="pickerOptions"
                  type="date"
                  placeholder="Ngày hiệu lực"
                  :format="'dd/MM/yyyy'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>
        </el-form>
      </div>
      <div class="preview">
        <div class="preview-content">
          <iframe
            id="iframe-preview"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>

    <div class="d-flex at-center button-group" v-if="MethodService.checkHaveFeature('FT1804')">
      <el-button
        type="danger"
        plain
        @click="onCancelForm"
      >
        Hủy
      </el-button>
      <el-button
        type="primary"
        @click="onSubmitForm"
      >
        Tiếp theo
      </el-button>
    </div>
  </div>
</template>
<script>
import MethodService from '../../../../service/MethodService'
import DraffDocumentAutoModel from './DraffDocumentAutoModel'
import DdaTemplateApi from "@/moduleApi/DdaTemplateApi"
import DdaCategoryApi from "@/moduleApi/DdaCategoryApi"
import DdaCodesApi from '@/moduleApi/DdaCodesApi'
import DraffDocumentAutoApi from '@/moduleApi/DraffDocumentAutoApi'
import toastr from 'toastr'

export default {
  data() {
    return {
      MethodService,
      haveEffectedDate: false,
      dataForm: MethodService.copyObject(DraffDocumentAutoModel.dataForm),
      currentUser: MethodService.getCurrentUser(),
      userProfile: MethodService.getUserProfile(),
      validForm: DraffDocumentAutoModel.validForm,
      bodyIfarme: '',
      content: '',
      moduleName: 'DocumentDrafting',
      isEdit: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime()
        },
      },
      dataDefault: {
        listTemplates: [],
        listCategories: [],
        listParamMergeFileds: [],
        company: MethodService.getCompanyInfo(),
        listCategoriesAndCode: []
      }
    }
  },
  methods: {
    forceUpdateUI() {
      this.$forceUpdate()
    },
    async inintDataDefault() {
      this.dataDefault.listCategoriesAndCode = []
      let ddaTemplateApiRes
      let ddaCategoryApiRes
      let allParamMergeFields
      [ddaTemplateApiRes, ddaCategoryApiRes, allParamMergeFields] = await Promise.all([
        DdaTemplateApi.list({
          limit: 1000,
          fields: 'id,name,dda_category_id,content'
        }),
        DdaCategoryApi.list({
          limit: 100,
          fields: 'id,name,code'
        }),
        DdaTemplateApi.GetParamValuesForContractTemplate()
      ])
      this.dataDefault.listTemplates = ddaTemplateApiRes.result || []
      this.dataDefault.listCategories = ddaCategoryApiRes.result
      this.dataDefault.listParamMergeFileds = allParamMergeFields.result
      if (this.dataDefault.listParamMergeFileds['{{@SoHopDong}}'] == "") {
        this.dataDefault.listParamMergeFileds['{{@SoHopDong}}'] = '......................'
      }
    },
    async onChangeTemplate(ddaTemplateId){
      if (!ddaTemplateId) {
        this.dataForm.dda_category_id = null
        this.dataForm.code = null
        return
      }
      let template = this.dataDefault.listTemplates.find(item => item.id == ddaTemplateId)
      this.dataForm.dda_category_id = template.dda_category_id
      const header = template.content && template.content.header ? template.content.header : "";
      const body = template.content && template.content.body ? template.content.body : "";
      const footer = template.content && template.content.footer ? template.content.footer : "";
      this.content = header + body + footer;
      if (this.checkHaveCategory(ddaTemplateId)) {
        let data = this.checkHaveCategory(ddaTemplateId)
        this.dataForm.code = data.code
        this.setContentToIframe(this.content)
        return
      }
      let res
      [res] = await Promise.all([
        DdaCodesApi.getLastestCode(template.dda_category_id)
      ])
      if (res.result) {
        if (res.result.code) {
          this.dataForm.code = res.result.code.Code ? res.result.code.Code : ''
          if (res.result.code.WarningMessage && this.userProfile.type != 'COMPANY') {
            toastr.warning(res.result.code.WarningMessage)
          }
        }
        this.dataDefault.listCategoriesAndCode.push({
          id: ddaTemplateId,
          dda_category_id: template.dda_category_id,
          code: this.dataForm.code
        })
        this.setContentToIframe(this.content)
      }
      if (this.dataForm.code) {
        this.$refs["formCreate"].clearValidate("code")
      }
    },
    changeCode(code) {
      this.setContentToIframe(this.content)
    },
    setContentToIframe(content) {
      setTimeout(() => {
        this.dataDefault.listParamMergeFileds['{{@SoVanBan}}'] = this.dataForm.code
        this.bodyIfarme = MethodService.mergeField(
          MethodService.decodeHTML(content),
          this.dataDefault.listParamMergeFileds
        )
        let iframeDiv = document.getElementById('iframe-preview').contentWindow.document.body
        iframeDiv.innerHTML = this.bodyIfarme
        // iframeDiv.style.padding = "30pt"
        iframeDiv.style.width = "210mm"
        iframeDiv.style.margin = "0 auto"
        iframeDiv.getElementsByTagName("div")[0].style.padding = "10mm 15mm"
      }, 400)
    },
    checkHaveCategory(ddaTemplateId) {
      if (!ddaTemplateId) {
        return false
      }
      let template = this.dataDefault.listCategoriesAndCode.find(item => item.id == ddaTemplateId)
      if (template) {
        return template
      }
      return false
    },
    forceUpdateUI() {
      this.$forceUpdate()
    },
    onChangeEffectedDate(haveEffectedDate) {
      if (!haveEffectedDate)  this.dataForm.effected_date = undefined
    },
    onCancelForm(){
      // this.$router.push({name: 'Admin-DocumentDrafting-list'}).catch(err => {})
      this.$router.go(-1)
    },
    async onSubmitForm() {
      this.$refs['formCreate'].validate(async valid => {
        if (!valid) {
          MethodService.stopLadda()
          return
        }
        let data = MethodService.copyObject(this.dataForm)
        data.html = this.bodyIfarme
        try {
          if (this.isEdit) {
            await DraffDocumentAutoApi.update(data)
            this.$router.push({
              name: "Admin-" + this.moduleName + "-update-drafting",
              params: {
                id: data.id
              }
            }).catch(err => {})
          } else {
            await DraffDocumentAutoApi.CheckCode({
              code: data.code
            })
            localStorage.setItem('dataForm', JSON.stringify(data))
            this.$router.push({
              name: "Admin-" + this.moduleName + "-create-drafting"
            }).catch(err => {})
          }
        } catch (error) {
          toastr.error(error.message)
        }
      })
    },
    getDataFromLocalStorage() {
      let data = localStorage.getItem('dataForm')
      if (data) {
        this.dataForm = JSON.parse(data)
        this.content = this.dataForm.html
        this.setContentToIframe(this.content)
        this.haveEffectedDate = this.dataForm.effected_date ? true : false
      }
    },
    async getDataById(id) {
      const res = await DraffDocumentAutoApi.findById(id)
      if (res.result) {
        this.dataForm = res.result
        // console.log('this.dataForm', this.dataForm)
        this.content = this.dataForm.html
        this.setContentToIframe(this.content)
        if (!this.dataForm.effected_date) {
          this.dataForm.effected_date = undefined
        }
        this.haveEffectedDate = this.dataForm.effected_date ? true : false
        this.isEdit = true
      }
    }
  },
  mounted() {
    MethodService.checkHavePermission('FT1804')
    this.inintDataDefault()
    this.getDataFromLocalStorage()
    if (this.$route.params.id) {
      this.getDataById(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  width: 620px;
  padding: 5px;
  background: #fff;
  margin-right: 25px;
  height: calc(100vh - 145px);
  .form__create {
    height: calc(100vh - 155px);
    overflow-y: auto;
    padding: 10px;
    border: 1px solid #7E7E7E;
  }
}
.button-group {
  justify-content: flex-end;
  margin-top: 10px;
}
.preview {
  width: 100%;
  background: #fff;
  .preview-title {
    font-size: 15px;
  }
  .preview-content {
    box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    height: calc(100vh - 145px);
  }
}
.title-note {
  font-size: 15px;
  line-height: 22px;
}
::v-deep .custom-label {
  width: 390px;
  align-items: center;
  justify-content: space-between;
  .el-switch {
    .el-switch__core {
      border-radius: 10px;
      &:after {
        border-radius: 10px;
      }
    }
  }
}

::v-deep span {
  font-family: LexendDeca Regular !important;
}
::v-deep .el-select-dropdown {
  .el-scrollbar {
    .el-select-dropdown__wrap {
      .el-select-dropdown__list {
        .el-select-dropdown__item {
          span{
            font-family: LexendDeca Regular !important;
          }
        }
      }
    }
  }
}
</style>
